import { ProtectedComponent } from '@/domain/components/rbac/ProtectedComponent';
import { usePermission } from '@/domain/context/rbac';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Report } from '@/domain/types/collections';
import useGetDocument from '@/domain/use-cases/get-document';
import AlertMessage from '@/presentation/components/alert-message';
import CommentsDetailDocument from '@/presentation/components/detail-document/comments';
import HeaderDetailDocument from '@/presentation/components/detail-document/header';
import StatsDetailDocument from '@/presentation/components/detail-document/stats';
import FormAddReport from '@/presentation/components/form-add-report';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const ReportDetailsPage = () => {
  const [isAlertMessageOpen, setIsAlertMessageOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const canDelete = usePermission('reports', 'delete');

  const {
    data,
    error,
    isLoading,
    updateDocument,
    deleteDocument,
    deleteComment,
    comments,
  } = useGetDocument<Report>(DOCUMENTS_DB.REPORTS, id);

  const handleDelete = async () => {
    try {
      await deleteDocument();
      toast.success('Reporte eliminado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/reports');
    } catch (error) {
      console.log(error);
      toast.error('Error al eliminar el reporte', { theme: 'colored' });
    }
  };

  const handleSave = async (updateData: Report) => {
    try {
      const updatedData = { ...data, ...updateData };
      console.log(updatedData);
      await updateDocument(updatedData);
      toast.success('Reporte actualizado correctamente', {
        theme: 'colored',
      });
    } catch (error) {
      console.log(error);
      toast.error('Error al actualizar el reporte', { theme: 'colored' });
    }
  };

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data) return <div>No data</div>;

  return (
    <ProtectedComponent
      resource="reports"
      action="read"
      fallback={
        <div className="flex justify-center items-center min-h-96">
          <div className="text-center">
            <h2 className="text-lg font-medium text-gray-900">
              Acceso Denegado
            </h2>
            <p className="text-gray-600 mt-1">
              No tienes permisos para ver esta página
            </p>
          </div>
        </div>
      }
    >
      <div className="p-4 flex flex-row md:flex-col gap-8">
        <HeaderDetailDocument
          title={data.title}
          handleDelete={() => setIsAlertMessageOpen(true)}
          showDeleteButton={canDelete}
        />

        <StatsDetailDocument data={data} />

        <FormAddReport onSave={handleSave} document={data} />

        <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
          <CommentsDetailDocument
            data={comments}
            deleteComment={deleteComment}
          />
        </div>

        <AlertMessage
          title="Eliminar Reporte"
          message="¿Estás seguro de querer eliminar este reporte?"
          onConfirm={handleDelete}
          onCancel={() => setIsAlertMessageOpen(false)}
          isOpen={isAlertMessageOpen}
        />
      </div>
    </ProtectedComponent>
  );
};

export default ReportDetailsPage;
